import { AvailablePaymentMethod } from "gql/types";

export const isPaymentRequiredGQL = (
  reservations: {
    paymentPolicy: { noPaymentRequiredUntil: string | null } | null;
  }[],
  paymentMethodType?: AvailablePaymentMethod["__typename"],
) => {
  if (paymentMethodType === "AvailablePaymentMethodWireTransfer") {
    return false;
  }

  return reservations.some((r) => {
    return !r.paymentPolicy?.noPaymentRequiredUntil;
  });
};

// This voucher codes are used as a hack for traffic arriving for metasearch clicks (Mirai)
// It confuses uses so we are ignoring them for feedback feature
export const disallowedVoucherCodesForFeedback = [
  "STAYLIBERE",
  "STAYB48",
  "KOISIHOSTEL",
];

export const MAX_RESERVATIONS_PER_PURCHASE = 9;

export class CreateReservationError extends Error {}

export class CreateReservationNoAvailabilityError extends Error {}

export class CreateReservationInvalidArgumentError extends Error {
  constructor(field: string) {
    super(`Invalid argument for field ${field}`);
    this._field = field;
  }

  private _field: string;

  get field(): string {
    return this._field;
  }
}
